var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotionReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12048",
    "data-name": "Group 12048",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.035,
    height: 19.095,
    viewBox: "0 0 19.035 19.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4303",
    "data-name": "Rectangle 4303",
    width: 19.035,
    height: 19.095,
    fill: "#393939"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12047",
    "data-name": "Group 12047",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5126",
    "data-name": "Path 5126",
    d: "M16.992,7.915v.173c0,2.98.006,5.96,0,8.94a2.013,2.013,0,0,1-1.022,1.8,2.084,2.084,0,0,1-1.1.263q-5.339,0-10.678,0a2.022,2.022,0,0,1-1.956-1.23,2.139,2.139,0,0,1-.181-.933q0-4.417,0-8.833V7.92L1.948,8c-.281.239-.553.489-.844.714A.673.673,0,0,1,.022,8.323.6.6,0,0,1,.2,7.709c.216-.2.442-.388.666-.579L4.2,4.3,8,1.069Q8.511.635,9.021.2A.7.7,0,0,1,9.994.194c.7.592,1.4,1.191,2.1,1.784.492.417.988.828,1.48,1.245.465.394.926.792,1.39,1.187s.939.8,1.409,1.2q1.191,1.01,2.383,2.02a.685.685,0,0,1,.157.948.651.651,0,0,1-.934.16c-.282-.22-.549-.458-.823-.689l-.16-.131M9.525,17.733h5.254c.053,0,.106,0,.159,0a.678.678,0,0,0,.65-.474,1.329,1.329,0,0,0,.046-.367q0-3.468,0-6.937c0-1.026,0-2.053,0-3.079a.227.227,0,0,0-.061-.156Q14.383,5.7,13.187,4.683,11.87,3.565,10.553,2.449c-.311-.264-.619-.53-.927-.8-.062-.053-.11-.075-.189-.007C8.821,2.175,8.2,2.7,7.583,3.224Q5.543,4.959,3.5,6.691a.246.246,0,0,0-.1.214q0,5,0,10.005c0,.036,0,.071,0,.107a.689.689,0,0,0,.5.677,1.455,1.455,0,0,0,.357.037q2.632,0,5.265,0",
    transform: "translate(-0.001 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5127",
    "data-name": "Path 5127",
    d: "M114.884,145.055a.681.681,0,0,1-.2.48c-.3.352-.6.705-.911,1.053q-1.262,1.432-2.529,2.859-.934,1.055-1.868,2.11a.719.719,0,0,1-.755.27.652.652,0,0,1-.36-1.019c.143-.189.3-.37.455-.548q.665-.76,1.336-1.514l1.36-1.536c.451-.509.9-1.02,1.353-1.527.319-.357.642-.709.966-1.061a.63.63,0,0,1,.643-.205.648.648,0,0,1,.506.639",
    transform: "translate(-101.991 -136.189)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M181.894,216.323a2.021,2.021,0,0,1,2.01,2.07,2,2,0,0,1-2,1.991,2.03,2.03,0,0,1-.013-4.061m.683,2.014a.686.686,0,1,0-.675.7.713.713,0,0,0,.675-.7",
    transform: "translate(-169.653 -204.029)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M86.31,136.416a2.026,2.026,0,1,1,1.945-1.992,1.994,1.994,0,0,1-1.945,1.992m.614-2.027a.686.686,0,1,0-.674.69.712.712,0,0,0,.674-.69",
    transform: "translate(-79.437 -124.843)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionReportIcon);
export default __webpack_public_path__ + "static/media/promotion-report-icon.bc154924117f132ed2a3a035d63684cf.svg";
export { ForwardRef as ReactComponent };